module.exports = __webpack_public_path__ + "img/switch.3d296e3b.png";